import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { getAccessToken, putData } from "../common/MSALHelper";
import { useMsal } from "@azure/msal-react";

export default function Contribution(props) {
    const { instance, accounts } = useMsal();
    const { contribution_id } = useParams();
    const [formData, setFormData] = useState({
        amount: '',
        date: '',
        mark: false,
        note: '',
        thankYouNoteSent: false
    });
    useEffect(() => {
    })

    const onSubmit = async (event) => {
        event.preventDefault();

        try {
            getAccessToken(instance, accounts).then((response) => {
                let accessToken = response;
                putData(accessToken, `/contribution`, response => {
                    if (response.ok) {
                        // Contribution updated successfully
                        console.log('Contribution updated successfully');
                    } else {
                        // Handle error response
                        console.error('Failed to update contribution');
                    }
                }, data => {

                }, JSON.stringify({
                    ...formData,
                    oldAmount: '', // Provide old amount
                    oldDate: '',   // Provide old date
                    oldMark: '',   // Provide old mark
                    oldNote: '',   // Provide old note
                    oldThankYouNoteSent: '' // Provide old thank you note sent
                }))
            });
        } catch (error) {
            // Handle fetch error
            console.error('Error updating contribution:', error);
        }
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData({ ...formData, [name]: newValue });
    };

    return <div>
        <h2>Update Contribution</h2>
        <form id="updateForm" onSubmit={onSubmit}>
            <label htmlFor="contribution_id">ID: </label><br />
            <input type="text" id="contribution_id" name="contribution_id" required readOnly value={contribution_id} /><br />

            <label htmlFor="amount">Amount:</label><br />
            <input type="text" id="amount" name="amount" required onChange={handleChange} /><br />

            <label htmlFor="date">Date:</label><br />
            <input type="date" id="date" name="date" required onChange={handleChange} /><br />

            <label htmlFor="mark">Mark:</label><br />
            <input type="checkbox" id="mark" name="mark" onChange={handleChange} /><br />

            <label htmlFor="note">Note:</label><br />
            <input type="text" id="note" name="note" onChange={handleChange} /><br />

            <label htmlFor="thankYouNoteSent">Thank You Note Sent:</label><br />
            <input type="checkbox" id="thankYouNoteSent" name="thankYouNoteSent" onChange={handleChange} /><br />

            <button type="submit">Update Contribution</button>
        </form>
    </div>
}